//For updating total price on product page bundle
(function() {
    let bundleCheckboxes = document.getElementsByClassName("bundled_product_checkbox");
    let bundlePriceDisplay = document.getElementById("bundle-price");
    let incrementButtons = document.querySelectorAll('button[data-bundle-update-quantity="increment"]');
    let decrementButtons = document.querySelectorAll('button[data-bundle-update-quantity="decrement"]');

    function initBundle() {
        for (i = 0; i < bundleCheckboxes.length; i++) {
            bundleCheckboxes[i].addEventListener("click", updateBundleTotal);
        }
        for (i = 0; i < incrementButtons.length; i++) {
            incrementButtons[i].addEventListener("click", incrementItem);
        }
        for (i = 0; i < decrementButtons.length; i++) {
            decrementButtons[i].addEventListener("click", decrementItem);
        }
    }

    function updateBundleTotal() {
        let bundlePrice = parseInt(document.getElementById("bundled-products").getAttribute('data-main-product-price'));
        for (i = 0; i < bundleCheckboxes.length; i++) {
            let bundledproductQuantity = parseInt(bundleCheckboxes[i].getAttribute('data-bundled-product-quantity'));
            if(bundleCheckboxes[i].checked && bundledproductQuantity <= 0 ){//first checked
                bundledproductQuantity = 1;
                bundlePrice = bundlePrice + (parseInt(bundleCheckboxes[i].getAttribute('data-bundled-product-price')) * bundledproductQuantity);
                bundleCheckboxes[i].dataset.bundledProductQuantity = 1;
                bundleCheckboxes[i].closest('.individual-bundled-product').querySelector('.count-indicator').innerHTML = "1";
                bundleCheckboxes[i].closest('.individual-bundled-product').querySelector('.count-indicator').style.display = "block";
            }else if(bundleCheckboxes[i].checked && bundledproductQuantity >= 1){ //already checked with at least one item
                bundlePrice = bundlePrice + (parseInt(bundleCheckboxes[i].getAttribute('data-bundled-product-price')) * bundledproductQuantity);
            }else if(bundleCheckboxes[i].checked == false){ //unchecked
                resetCounter(bundleCheckboxes[i]);
            }
        }
        bundlePriceDisplay.innerHTML = new Intl.NumberFormat('fi-FI', { style: 'currency', currency: 'EUR' }).format(bundlePrice * 0.01);
    }

    function resetCounter(bundledInput) {
        bundledInput.dataset.bundledProductQuantity = 0;
        bundledInput.closest('.individual-bundled-product').querySelector('.count-indicator').style.display = "none";
    }    

    function incrementItem() {
        let input = this.closest('.individual-bundled-product').querySelector('input');
        let countIndicator = this.closest('.individual-bundled-product').querySelector('.count-indicator');
        let newQuantity = parseInt(input.dataset.bundledProductQuantity) + 1;
        input.setAttribute("data-bundled-product-quantity", newQuantity.toString());
        if(newQuantity > 0){
            input.checked = true;
            countIndicator.style.display = "block";
        }else {
            countIndicator.style.display = "none";
        }
        countIndicator.innerHTML = newQuantity;
        updateBundleTotal();
    }

    function decrementItem() {
        let input = this.closest('.individual-bundled-product').querySelector('input');
        let countIndicator = this.closest('.individual-bundled-product').querySelector('.count-indicator');
        let newQuantity = parseInt(input.dataset.bundledProductQuantity) - 1;
        input.setAttribute("data-bundled-product-quantity", newQuantity.toString());        
        if(newQuantity <= 0 ) {
            newQuantity = 0;
            input.checked = false;
            countIndicator.style.display = "none";
        }else {
            input.checked = true;
            countIndicator.style.display = "block";
        }
        countIndicator.innerHTML = newQuantity;
        updateBundleTotal();
    }
   
    if (document.readyState === "complete" || document.readyState === "loaded") {
        initBundle();
    } else {
      document.addEventListener("DOMContentLoaded", initBundle);
    }
})();